/* eslint-disable @typescript-eslint/no-explicit-any */
export type GTAG = (...args: any[]) => void;

export function globalGTAG(): GTAG {
  return (window as any).gtag;
}
